const initialState = {
    token: localStorage.getItem("accessToken") || null,
};

const tokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_TOKEN":
            localStorage.setItem("accessToken", action.payload);
            return {
                ...state,
                token: action.payload,
            };

        case "REMOVE_TOKEN":
            localStorage.removeItem("accessToken");
            localStorage.removeItem("csrfToken");
            localStorage.removeItem("loginTime");
            return {
                token: null,
            };

        default:
            return state;
    }
};

export default tokenReducer;
